import Http from 'services/Http';
import sanitizeAgenticBody from './sanitizeAgenticBody';

class SecretApi {
  list() {
    return Http.get('/v1/secrets').then(r => r.data.secrets);
  }

  get(id) {
    return Http.get(`/v1/secrets/${id}`).then(r => r.data.secret);
  }

  create(body) {
    return Http.post('/v1/secrets', sanitizeAgenticBody(body)).then(r => r.data.secret);
  }

  update(id, body) {
    return Http.put(`/v1/secrets/${id}`, sanitizeAgenticBody(body)).then(r => r.data.secret);
  }

  destroy(id) {
    return Http.delete(`/v1/secrets/${id}`);
  }
}

export default new SecretApi();
